export const IS_LOGGED_FROM_SERVICE_KEY = 'isLoggedFromService';

export const setIsLoggedFromService = (): void => {
  localStorage.setItem(IS_LOGGED_FROM_SERVICE_KEY, 'true');
};

export const clearIsLoggedFromService = (): void => {
  localStorage.removeItem(IS_LOGGED_FROM_SERVICE_KEY);
};

export const isLoggedFromService = (): boolean => localStorage.getItem(IS_LOGGED_FROM_SERVICE_KEY) === 'true';
